export default __webpack_public_path__ + "assets/wav/c5fd23366fc8bfd7ec27cb13da6789ef.wav";